import { get } from "../../helpers/api_helper";
const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";

export const getNonDrinkers = async (data) =>
  await get(
    `${API_URL}admission/non-drinkers?days=${data.days || 0}&exact=${
      data.exact || 0
    }`
  );
